<template>
  <div
    :class="[
      'card-layout',
      { aboveSearch, fullHeight, expanded, mobileExpanded },
    ]"
    data-test="card"
  >
    <slot />
    <mobile-prototype-card-handle @click="toggleMobileCard" />
  </div>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
import mobilePrototypeCardHandle from '@/components/mobile-prototyping/mobile-prototype-card-handle.vue'

/**
 * Establishes the layout properties and props for a card
 */

export default {
  name: 'CardLayout',
  components: {
    mobilePrototypeCardHandle,
  },
  props: {
    /**
     * Display card above the search bar
     */
    aboveSearch: {
      type: Boolean,
      default: false,
    },
    /**
     * Display the card at full viewport height (minus spacing)
     */
    fullHeight: {
      type: Boolean,
      default: false,
    },
    /**
     * Display the card at expanded width
     */
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mobileExpanded: false,
    }
  },
  methods: {
    toggleMobileCard() {
      this.mobileExpanded = !this.mobileExpanded
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/system/_colors.scss';
@use '@/styles/system/_shadow.scss';
@use '@/styles/system/_breakpoints.scss';
@use '@/styles/_layer-map.scss';

.card-layout,
.card-layout.side-panel.panel-view {
  --card-top-offset: 75px;
  --card-bottom-offset: 20px;
  --card-banner-offset: 0px;
  --card-expanded-width: 750px;

  $card-top: calc(var(--card-top-offset) + var(--card-banner-offset));

  display: flex;
  flex-direction: column;
  background: colors.$BaseWhite;
  position: absolute;
  top: $card-top;
  left: 120px;
  width: var(--card-width);
  border-radius: 10px;
  z-index: layer-map.$z-index-level-card;
  height: auto;
  max-height: calc(100% - (#{$card-top} + var(--card-bottom-offset)));
  box-shadow: shadow.$Medium;
  padding: 0;

  &.aboveSearch {
    --card-top-offset: 20px;
    z-index: layer-map.$z-index-level-above-controls;
  }

  &.fullHeight {
    height: 100%;
  }

  &.expanded {
    width: calc(100vw - 75px);
    top: var(--card-banner-offset);
    left: 75px;
    border-radius: 0 10px 10px 0;
    height: calc(100vh - var(--card-banner-offset));
    max-height: 100vh;
    box-shadow: rgba(0, 0, 0, 0.14) 7px 0px 5px -5px inset;
    overflow-x: hidden;
    z-index: layer-map.$z-index-level-above-controls;

    @include breakpoints.medium {
      left: 100px;
      width: calc(100vw - 100px);
    }

    @include breakpoints.extra-large {
      width: calc(100vw - 100px);
      max-width: var(--card-expanded-width);
    }
  }

  .with-banner & {
    --card-banner-offset: var(--map-banner-height);

    @include breakpoints.mobile {
      max-height: calc(100vh - 130px);
    }
  }

  @include breakpoints.mobile {
    --card-width: 360px;
    left: 15px;
  }

  @include breakpoints.app-prototyping {
    --card-width: 100vw;
    left: 0;
    max-height: calc(100% - (#{$card-top} + var(--card-bottom-offset)) + 20px);
    border-radius: 10px 10px 0 0;
    top: auto;
    bottom: 0;
    height: var(--mobile-card-half-detent-height);
    transition: height 0.25s ease-in-out;

    &.mobileExpanded {
      height: 100%;
    }

    :deep(ys-card) {
      max-width: none;
    }
  }
}
</style>
